<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '70px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="预测单号">
              <global-select
                :value.sync="queryParams.fcCode"
                selectType="selectSearch"
                requestApi="/scp/scpFcSporadic/scpFcCodeList"
                :selectItem="{ value: 'label', label: 'label' }"
                searchParam="inputString" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码">
              <global-select
                :assembleLabel="false"
                :value.sync="queryParams.itemCode"
                selectType="selectSearch"
                requestApi="/mes/mesDiscreteJobs/assemblyBox"
                :selectItem="{ value: 'selectedValue', label: 'selectedValue' }"
                searchParam="itemCode" />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="来源单号">
              <global-select
                :value.sync="queryParams.sourceCode"
                selectType="selectSearch"
                requestApi="/scp/scpFcSporadic/sourceCodeList"
                :selectItem="{ value: 'label', label: 'label' }"
                searchParam="inputString" />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="需求交期">
                <!--<a-date-picker valueFormat="YYYY-MM-DD" format="YYYY-MM-DD" v-model="queryParams.demandDeliveryDate" />-->
                <a-range-picker
                  class="rp-width"
                  :placeholder="['需求交期从', '需求交期至']"
                  valueFormat="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  :value="demandDeliveryDate"
                  @change="handlePanelChange"
                />
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParams.scpFcStatus" allowClear>
                  <a-select-option v-for="(item) in statusOptions" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="申请人">
                <global-select
                  selectType="selectSearch"
                  :value.sync="queryParams.applicant"
                  requestApi="/scp/scpFcSporadic/applicantBox"
                  :selectItem="{ value: 'label', label: 'label' }"
                  searchParam="name"
                />
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="事业部">
                <global-select
                  :value.sync="queryParams.department"
                  selectType="selectSearch"
                  requestApi="/system/lookup/data/likeList"
                  :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                  :setParams="{ lookupType: 'SCP_BUSINESS_UNIT' }"
                  searchParam="lookupValue"
                  :dropdown-match-select-width="false"
                />
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="申请时间">
                <a-range-picker
                  class="rp-width"
                  :placeholder="['申请时间从', '申请时间至']"
                  valueFormat="YYYY-MM-DD"
                  format="YYYY-MM-DD"
                  :value="applicationTime"
                  @change="onChangeApplicationTime"
                />
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="项目组">
                <a-select :max-tag-count="1" show-search allowClear option-filter-prop="children" v-model="queryParams.projectTeam" >
                  <a-select-option v-for="(item) in projectTeams" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="需求类型">
                <global-select
                  ref="demandTypeRef"
                  selectType="selectSearch"
                  :value.sync="queryParams.demandType"
                  requestApi="/scp/scpDemandPlacementBill/demandTypeCombobox"
                  :selectItem="{ value: 'realValue', label: 'label' }"
                  searchParam="demandType"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button :disabled="this.scpFcStatus!=='10'||this.scpFcStatus === undefined " @click="distributeMsg(15)" type="primary" :loading="loading">下发</a-button>
      <a-button :disabled="this.scpFcStatus==='20'||this.scpFcStatus === undefined " @click="distributeMsg(20)" type="primary" :loading="loading">关闭</a-button>
      <a-button :disabled="this.scpFcStatus!=='20'||this.scpFcStatus === undefined " @click="distributeMsg(10)" :loading="loading">状态恢复</a-button>
      <a-button @click="handleExport" type="primary" :loading="loading">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          :selectedRows.sync="selectedRows"
          :multi-select="true"
          rowKey="id"
          @selectedRowChange="selectedRowChange"
          :scroll="{ fixScreen: true, x: 1300 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.SPORADIC_FORECAST_LIST, // 表格方案配置唯一值
              }"
        >
          <!-- 主要代码在这里 -- 下面这些 -->
          <template slot="bzbz" slot-scope="{ text }">
            <a-tooltip placement="top">
              <template slot="title">
                <span>{{ text }}</span>
              </template>
              <span class="ellipsis">{{ text }}</span>
            </a-tooltip>
          </template>
          <span slot="indexId" slot-scope="{index}">
            {{ index+1 }}
          </span>
          <template slot="isStopFlag" slot-scope="{ record }">
            <span >{{ record.isStopFlag === 'Y' ? '是' : '否' }}</span>
          </template>
          <template slot="updateTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="formatDate" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY/MM/DD') }}</span>
          </template>
          <template slot="expirationDate" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY/MM/DD') }}</span>
          </template>
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="time" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY/MM/DD HH:mm') }}</span>
          </template>
          <!-- <template slot="status" slot-scope="{ record }">
            <a-popconfirm
              ok-text="确定"
              cancel-text="取消"
              @confirm="confirmHandleStatus(record)"
              @cancel="cancelHandleStatus(record)"
            >
              <span slot="title">请确认是否<b>{{ record.status === 'Y' ? '停用' : '启用' }}</b>该单位</span>
              <a-switch :checked="record.status === 'Y'" />
            </a-popconfirm>
          </template> -->
        </ls-api-table>
        <!-- <create-form
          ref="createModal"
          :uomClassOptions="uomClassOptions"
          @handle-success="onSearch"
        /> -->
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
// import CreateForm from './components/CreateForm'
import { generateLsTableResData } from '@/utils/util.js'
import { apiScpFcSporadicList, apiScpFcSporadic } from '@/api/scp/sporadic-demand/sporadic-forecast'
import cloneDeep from 'lodash.clonedeep'

export default {
  // eslint-disable-next-line
  name: 'Sporadic-forecast',
  data () {
    return {
      loading: false,
      projectTeams: [], // 项目组
      scpFcStatus: '',
      // 表格配置1
      tableProps: {
        requestApi: generateLsTableResData(apiScpFcSporadicList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      demandDeliveryDate: undefined,
      applicationTime: undefined, // 申请时间
      // 查询参数
      queryParams: {
        fcCode: undefined,
        scpFcStatus: '10',
        demandDeliveryDateFrom: undefined,
        applicationTimeFrom: undefined,
        demandDeliveryDateTo: undefined,
        applicationTimeTo: undefined,
        itemCode: undefined,
        sourceCode: undefined,
        applicant: undefined,
        projectTeam: undefined,
        demandType: undefined,
        department: undefined
      },
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      // 状态快码
      statusOptions: [
        {
          dictLabel: "未下发",
          dictValue: "10"
        },
        {
          dictLabel: "已下发",
          dictValue: "15"
        },
        {
          dictLabel: "关闭",
          dictValue: "20"
        }
        // ,
        // {
        //   dictLabel: "已作废",
        //   dictValue: "99"
        // }
      ],
      baseUomFlagOptions: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      // 表格字段
      columns: [
        {
          title: '序号',
          scopedSlots: { customRender: 'indexId' },
          dataIndex: 'indexId',
          stickyFixed: 'left',
          align: 'center',
          width: 60
        },
        {
          title: '预测单号',
          dataIndex: 'fcCode',
          ellipsis: true,
          width: 140,
          stickyFixed: 'left',
          align: 'center'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          ellipsis: true,
          width: 140,
          stickyFixed: 'left',
          align: 'center'
        },
        {
          title: '物料名称',
          stickyFixed: 'left',
          dataIndex: 'itemName',
          width: 110,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '规格描述',
          stickyFixed: 'left',
          dataIndex: 'specification',
          width: 180,
          align: 'left',
          ellipsis: true
          // scopedSlots: { customRender: 'bzbz' }
        },
        {
          title: '下单类别',
          dataIndex: 'orderType',
          width: 100,
          align: 'center'
        },
        {
          title: '销售类目',
          dataIndex: 'salesCategory',
          width: 100,
          align: 'center'
        },
        {
          title: '研发分类',
          dataIndex: 'developType',
          width: 100,
          align: 'center'
        },
        {
          title: '口径',
          dataIndex: 'caliberName',
          width: 100,
          align: 'center'
        },
        {
          title: '主型号',
          dataIndex: 'mainModel',
          ellipsis: true,
          width: 100,
          align: 'center'
        },
        {
          title: '是否停产',
          scopedSlots: { customRender: 'isStopFlag' },
          dataIndex: 'isStopFlag',
          width: 80,
          align: 'center'
        },
        {
          title: '需求数量',
          dataIndex: 'quantityDemand',
          width: 110,
          align: 'center'
        },
        {
          title: '需求交期',
          dataIndex: 'demandDeliveryDate',
          scopedSlots: { customRender: 'formatDate' },
          width: 110,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '当月回货需求',
          dataIndex: 'curMonthReturnDemand',
          width: 100,
          align: 'center'
        },
        {
          title: '当月回货需求日期',
          dataIndex: 'curMonthReturnDemandDate',
          scopedSlots: { customRender: 'formatDate' },
          width: 100,
          align: 'center'
        },
        {
          title: '次月回货需求',
          dataIndex: 'nextMonthReturnDemand',
          width: 100,
          align: 'center'
        },
        {
          title: '次月回货需求日期',
          dataIndex: 'nextMonthReturnDemandDate',
          scopedSlots: { customRender: 'formatDate' },
          width: 100,
          align: 'center'
        },
        {
          title: '供应余量',
          dataIndex: 'supplyRemainQty',
          width: 100,
          align: 'center'
        },
        {
          title: '是否在锁定期内',
          dataIndex: 'inLockFlag',
          width: 90,
          align: 'center',
          customRender: (text, record) => ({ 0: '否', 1: '是' }[record.inLockFlag])
        },
        {
          title: '是否提需求',
          dataIndex: 'commitDemandIs',
          width: 80,
          align: 'center',
          customRender: (text, record) => ({ 0: '否', 1: '是' }[record.commitDemandIs])
        },
        {
          title: '需求类型',
          dataIndex: 'demandDeliveryTypeName',
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'M+3月预测数量',
          dataIndex: 'forecastQtyM3',
          width: 90,
          // ellipsis: true,
          align: 'center'
        },
        {
          title: 'M+2月预测数量',
          dataIndex: 'forecastQtyM2',
          width: 90,
          // ellipsis: true,
          align: 'center'
        },
        {
          title: 'M+1月预测数量',
          dataIndex: 'forecastQtyM1',
          width: 90,
          align: 'center'
        },
        {
          title: '三个月内是否可消耗完',
          dataIndex: 'threeMonthConsumeIs',
          width: 100,
          align: 'center',
          customRender: (text, record) => ({ 0: '否', 1: '是' }[record.threeMonthConsumeIs])
        },
        {
          title: '预计消耗月数',
          dataIndex: 'expectConsumeMonth',
          width: 90,
          align: 'center'
        },
        {
          title: '需求备注',
          dataIndex: 'demandComment',
          width: 150,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '项目组',
          dataIndex: 'projectTeam',
          width: 110,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '来源单号',
          dataIndex: 'sourceCode',
          width: 180,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '事业部',
          dataIndex: 'businessUnitDesc',
          width: 110,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '店铺',
          dataIndex: 'store',
          width: 120,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '申请时间',
          dataIndex: 'applicationTime',
          scopedSlots: { customRender: 'time' },
          width: 140,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '申请人',
          dataIndex: 'applicant',
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'scpFcStatusDesc',
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '下发时间',
          dataIndex: 'issueTime',
          scopedSlots: { customRender: 'time' },
          width: 120,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '下发人',
          dataIndex: 'issuer',
          width: 100,
          align: 'center'
        },
        {
          title: '作废时间',
          dataIndex: 'nullifierTime',
          scopedSlots: { customRender: 'time' },
          width: 120,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '作废人',
          dataIndex: 'nullifier',
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '销售利润分类',
          dataIndex: 'salesProfitClassification',
          width: 100,
          align: 'center'
        }
      ],
      uomClassOptions: [],
      unitOfMeasureList: []
    }
  },
  created () {
    this.getProjectTeam();
  },
  mounted () {
    this.loading = false;
    this.onSearch()
  },
  methods: {
    // 获取项目组下拉数据
    getProjectTeam() {
      this.projectTeams = [];
      const lookupQueryProjectTeamParams = {
        lookupType: 'SCP_PROJECT_TEAM',
        current: 1,
        pageSize: 999
      }
      this.getLookupListData(lookupQueryProjectTeamParams).then().then(response => {
        this.projectTeams = response.rows
      })
    },
       /** 行选中 */
   selectedRowChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    /**
     *
     * @param {*} type
     * 零星预测：
     * 下发：2
     * 已下单：3
     * 作废：4
     */
    distributeMsg (type) {
      if (this.selectedRows.length === 0) {
        this.$message.error('请选中操作项')
        return
      }
      let typeTips = ''
      if (type === 15) {
        typeTips = '确定下发选中数据？'
      } else if (type === 20) {
        typeTips = '确定关闭当前零星预测行?'
      } else if (type === 10) {
        typeTips = '确认恢复状态吗？'
      }
      const self = this
      const newObjectArray = this.selectedRows.map(row => ({ id: row.id }));
      const params = {
        scpFcSporadicList: newObjectArray,
        status: type
      }
      this.$confirm({
        title: `提示`,
        content: typeTips,
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          self.loading = true;
          apiScpFcSporadic(params).then((response) => {
            self.loading = false;
            if (response.code === 200) {
              self.$message.success('提交成功')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          }).catch(() => {
            self.loading = false
          })
        }
      })
    },
    // uomClassOnChange () {
    //   this.getUnitOfMeasureList()
    // },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      this.$message.loading({ content: '导出中...' })
      const params = cloneDeep(this.queryParams)
      if (params.itemCode) { params.itemCode = [params.itemCode] }
      this.downloadByJson('scp/scpFcSporadic/export', params, `零星预测导出_${new Date().getTime()}.xlsx`)
    },
    // 申请时间变化
    onChangeApplicationTime(value) {
      this.queryParams.applicationTimeFrom = value?.length === 2 ? value[0] : undefined
      this.queryParams.applicationTimeTo = value?.length === 2 ? value[1] : undefined
      this.applicationTime = value?.length === 2 ? value : undefined
    },
    handlePanelChange (value) {
      const yearMonth1 = value[0]
      const yearMonth2 = value[1]
      this.queryParams.demandDeliveryDateFrom = yearMonth1
      this.queryParams.demandDeliveryDateTo = yearMonth2
      this.demandDeliveryDate = value
    },
    // getUnitOfMeasureList () {
    //   this.queryParams.unitOfMeasureList = undefined
    //   const params = {
    //     uomClassList: this.queryParams.uomClassList
    //   }
    //   unitOfMeasurelist(params).then(res => {
    //     if (res.code === 200 && res.data && res.data.length > 0) {
    //       const arr = res.data;
    //       const list = [];
    //       arr.forEach(element => {
    //         const obj = {
    //           key: element.realValue,
    //           value: element.label
    //         }
    //         list.push(obj)
    //       });
    //       this.unitOfMeasureList = list
    //     }
    //   })
    // },
    // confirmHandleStatus (row) {
    //   const text = row.status === 'Y' ? '停用' : '启用'
    //   row.status = row.status === 'Y' ? 'N' : 'Y'
    //   updateUnit(row)
    //   .then(() => {
    //     this.$message.success(
    //       text + '成功',
    //       3
    //     )
    //     this.onSearch()
    //   }).catch(function () {
    //     row.status = row.status === 'Y' ? 'N' : 'Y'
    //     this.$message.error(
    //       text + '发生异常',
    //       3
    //     )
    //   })
    // },
    // cancelHandleStatus (row) {
    // },
    baseUomFlagFormat (row, column) {
      return this.selectDictLabel(this.baseUomFlagOptions, row.baseUomFlag)
    },
    // 表单搜索
    onSearch () {
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    this.scpFcStatus = this.queryParams.scpFcStatus
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams.scpFcStatus = undefined;
      this.scpFcStatus = undefined;
      this.queryParams = {
        fcCode: undefined,
        scpFcStatus: undefined,
        demandDeliveryDate: undefined,
        itemCode: undefined,
        sourceCode: undefined,
        applicant: undefined,
        demandDeliveryDateFrom: undefined,
        demandDeliveryDateTo: undefined,
        applicationTimeFrom: undefined,
        applicationTimeTo: undefined,
        demandType: undefined,
        projectTeam: undefined,
        department: undefined
      }
      this.demandDeliveryDate = undefined
      this.applicationTime = undefined
      if(this.$refs?.demandTypeRef) this.$refs.demandTypeRef.handleSearch('');
      this.onSearch()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}.ellipsis{
    display:block;
    width:150px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }

</style>
